"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItemSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class StandardItemSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            globalId: data.globalId,
            subjectId: data.subjectId,
            courseId: data.courseId,
            subject: data.subject,
            course: data.course,
            code: data.code,
            shortCode: data.shortCode,
            description: data.description,
            hierarchyLevel: data.hierarchyLevel,
            hierarchyLevelSequence: data.hierarchyLevelSequence,
            standardSetId: data.standardSetId,
            ancestors: data.ancestors,
            children: data.children,
            examples: data.examples,
            topic: data.topic && this.serializeTopic(data.topic),
        };
    }
    serializeTopic(data) {
        return {
            metadata: data.metadata,
            id: data.id,
            name: data.name,
            level: data.level,
        };
    }
    serializeMapping(data) {
        return {
            id: data.id,
            standardItemGlobalId: data.standardItemGlobalId,
            mappedStandardItemGlobalId: data.mappedStandardItemGlobalId,
        };
    }
    serializeStandardItemSearch(data) {
        const items = data.data.map((st) => {
            return {
                id: st.id,
                globalId: st.globalId,
                code: st.code,
                shortCode: st.shortCode,
                description: st.description,
                subject: st.subject,
                status: st.status,
                courseId: st.courseId,
                course: st.course,
                themeId: st.themeId,
                theme: st.theme,
                standardSetId: st.standardSetId,
                standardSetGlobalId: st.standardSetGlobalId,
                hierarchyLevel: st.hierarchyLevel,
                hierarchyLevelProvider: st.hierarchyLevelProvider,
                hierarchyLevelSequence: st.hierarchyLevelSequence,
                standardItemsIncomplete: st.standardItemsIncomplete,
                hasPendingChanges: st.hasPendingChanges,
                standardItemChanges: st.standardItemChanges,
            };
        });
        const pagination = {
            page: data.meta.page,
            limit: data.meta.limit,
            itemsCount: data.meta.itemsCount,
            pagesCount: data.meta.pagesCount,
            hasPreviousPage: data.meta.hasPreviousPage,
            hasNextPage: data.meta.hasNextPage,
        };
        return { data: items, meta: pagination };
    }
    serializeRowsAffected(data) {
        return { data };
    }
}
exports.StandardItemSerializer = StandardItemSerializer;
//# sourceMappingURL=standard-item.serializer.js.map